<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part01"><a id="page_1"></a><strong><span class="small">I<br/>TEXAS: A CONFLICT OF CIVILIZATIONS</span></strong></h2>
<p class="paraspaceabove"><em>Of this far-famed corps—so much feared and hated by the Mexicans—I can add nothing to what has already been written. The character of the Texas Ranger is now well known by both friend and foe. As a mounted soldier he has had no counterpart in any age or country. Neither Cavalier nor Cossack, Mameluke nor Moss-trooper are like him; and yet, in some respects, he resembles them all. Chivalrous, bold and impetuous in action, he is yet wary and calculating, always impatient of restraint, and sometimes unscrupulous and unmerciful. He is ununiformed, and undrilled, and performs his active duties thoroughly, but with little regard to order or system. He is an excellent rider and a dead shot. His arms are a rifa, Colt’s revolving pistol, and a knife</em>.</p>
<p class="att">G<span class="small">IDDINGS</span>, <em>Sketches</em><a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?287e4a38